import React from 'react'
import { Link } from 'gatsby'

import Layout from '../components/layout'

const SecondPage = () => (
  <Layout>
<h1>Impressum</h1>

<h2>Angaben gem&auml;&szlig; &sect; 5 TMG</h2>
<p>Aufd Hand Catering und Kiosk, Pollner und Kiermeier GbR<br />
Malerweg 1<br />
83471 Sch&ouml;nau a. K&ouml;nigssee</p>

<p><strong>Vertreten durch:</strong><br />
Gerald Kiermeier<br />
Michael Josef Pollner</p>

<h2>Kontakt</h2>
<p>Telefon: +49 176 327 629 28     +49 176 226 819 19<br />
E-Mail: servus.aufd-hand@gmx.de</p>

<h2>Umsatzsteuer-ID</h2>
<p>Umsatzsteuer-Identifikationsnummer gem&auml;&szlig; &sect; 27 a Umsatzsteuergesetz:<br />
DE328876769</p>

<h2>Redaktionell Verantwortlicher</h2>
<p>Gerald Kiermeier / Michael Josef Pollner<br />
Malerweg 1<br />
83471 Sch&ouml;nau a. K&ouml;nigssee</p>


<h1>Datenschutzerklärung</h1>

<h2>Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle</h2>
<p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

<h3>Haftung f&uuml;r Inhalte</h3> <p>Als Diensteanbieter sind wir gem&auml;&szlig; &sect; 7 Abs.1 TMG f&uuml;r eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach &sect;&sect; 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, &uuml;bermittelte oder gespeicherte fremde Informationen zu &uuml;berwachen oder nach Umst&auml;nden zu forschen, die auf eine rechtswidrige T&auml;tigkeit hinweisen.</p> <p>Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unber&uuml;hrt. Eine diesbez&uuml;gliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung m&ouml;glich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p> <h3>Haftung f&uuml;r Links</h3> <p>Unser Angebot enth&auml;lt Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb k&ouml;nnen wir f&uuml;r diese fremden Inhalte auch keine Gew&auml;hr &uuml;bernehmen. F&uuml;r die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf m&ouml;gliche Rechtsverst&ouml;&szlig;e &uuml;berpr&uuml;ft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p> <p>Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p> <h3>Urheberrecht</h3> <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielf&auml;ltigung, Bearbeitung, Verbreitung und jede Art der Verwertung au&szlig;erhalb der Grenzen des Urheberrechtes bed&uuml;rfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur f&uuml;r den privaten, nicht kommerziellen Gebrauch gestattet.</p> <p>Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>

<p>Quelle: <a href="https://www.e-recht24.de">eRecht24</a></p>



<h2>Datenschutzerklärung für Facebook und Instagramm</h2>
<p>
Wir greifen unter anderem auf auf die technische
Plattform und die Dienste der Meta Ireland Ltd., 4 Grand Canal Square Grand Canal
Harbour, Dublin 2, Ireland zurück.
</p>

<p>
Wir weisen Sie darauf hin, dass Sie usere Facebook/Instagramm-Seite und ihre Funktionen in eigener
Verantwortung nutzen. Dies gilt insbesondere für die Nutzung der interaktiven Funktionen
(z.B. Kommentieren, Teilen, Bewerten). Alternativ können Sie die über diese Seite
angebotenen Informationen auch auf diesem Internet-Angebot abrufen.
    </p>
<p>
Beim Besuch unserer Facebook/Instagramm-Seite erfasst Facebook/Instagramm u.a Ihre IP-Adresse sowie weitere
Informationen, die in Form von Cookies auf Ihrem PC vorhanden sind. Diese
Informationen werden verwendet, um uns als Betreiber der Facebook/Instagramm-Seiten statistische
Informationen über die Inanspruchnahme der Facebook/Instagramm-Seite zur Verfügung zu stellen.
Nähere Informationen hierzu stellt Facebook/Instagramm unter folgendem Link zur Verfügung:
http://de-de.facebook.com/help/pages/insights
    </p>
<p>
Diese nutzen wir aber nicht. Wir kochen lieber.
    </p>

<p>
Die in diesem Zusammenhang über Sie erhobenen Daten werden von der Meta Ltd.
verarbeitet und dabei gegebenenfalls in Länder außerhalb der Europäischen Union
übertragen. Welche Informationen Facebook/Instagramm erhält und wie diese verwendet werden,
beschreibt Facebook/Instagramm in allgemeiner Form in seinen Datenverwendungsrichtlinien. Dort
finden Sie auch Informationen über Kontaktmöglichkeiten zu Facebook/Instagramm sowie zu den
Einstellmöglichkeiten für Werbeanzeigen. Die Datenverwendungsrichtlinien sind unter
folgendem Link verfügbar:
http://de-de.facebook.com/about/privacy
https://help.instagram.com/196883487377501
Die vollständigen Datenrichtlinien von Facebook finden Sie hier:
https://de-de.facebook.com/full_data_use_policy
</p>


<p>
In welcher Weise Facebook/Instagramm die Daten aus dem Besuch von Facebook/Instagramm-Seiten für eigene
Zwecke verwendet, in welchem Umfang Aktivitäten auf der Facebook/Instagramm-Seite einzelnen
Nutzern zugeordnet werden, wie lange Facebook/Instagramm diese Daten speichert und ob Daten aus
einem Besuch der Facebook/Instagramm-Seite an Dritte weitergegeben werden, wird von Facebook/Instagramm
nicht abschließend und klar benannt und ist uns nicht bekannt.
Beim Zugriff auf eine Facebook/Instagramm-Seite wird die Ihrem Endgeräte zugeteilte IP-Adresse an
Facebook/Instagramm übermittelt. Nach Auskunft von Facebook/Instagramm wird diese IP-Adresse anonymisiert
(bei "deutschen" IP-Adressen). Facebook/Instagramm speichert darüber hinaus Informationen über die
Endgeräte seiner Nutzer (z.B. im Rahmen der Funktion „Anmeldebenachrichtigung“);
gegebenenfalls ist Facebook/Instagramm damit eine Zuordnung von IP-Adressen zu einzelnen Nutzern
    möglich.
    </p>
<p>
Wenn Sie als Nutzerin oder Nutzer aktuell bei Facebook/Instagramm angemeldet sind, befindet sich
auf Ihrem Endgerät ein Cookie mit Ihrer Facebook/Instagramm-Kennung. Dadurch ist Facebook/Instagramm in der
Lage nachzuvollziehen, dass Sie diese Seite aufgesucht und wie Sie sie genutzt haben.
Dies gilt auch für alle anderen Facebook/Instagramm-Seiten. Über in Webseiten eingebundene
Facebook/Instagramm-Buttons ist es Facebook/Instagramm möglich, Ihre Besuche auf diesen Webseiten Seiten zu
erfassen und Ihrem Facebook/Instagramm-Profil zuzuordnen. Anhand dieser Daten können Inhalte
    oder Werbung auf Sie zugeschnitten angeboten werden.
</p>
<p>
Wenn Sie dies vermeiden möchten, sollten Sie sich bei Facebook/Instagramm abmelden bzw. die
Funktion "angemeldet bleiben" deaktivieren, die auf Ihrem Gerät vorhandenen Cookies
löschen und Ihren Browser beenden und neu starten. Auf diese Weise werden Facebook/Instagramm-
    Informationen, über die Sie unmittelbar identifiziert werden können, gelöscht. Damit
können Sie unsere Facebook/Instagramm-Seite nutzen, ohne dass Ihre Facebook/Instagramm-Kennung offenbart
wird. Wenn Sie auf interaktive Funktionen der Seite zugreifen (Gefällt mir, Kommentieren,
Teilen, Nachrichten etc.), erscheint eine Facebook/Instagramm-Anmeldemaske. Nach einer etwaigen
    Anmeldung sind Sie für Facebook/Instagramm erneut als bestimmte/r Nutzerin/Nutzer erkennbar.
</p>

<p>
Informationen dazu, wie Sie über Sie vorhandene Informationen verwalten oder löschen
können, finden Sie auf folgenden Facebook/Instagramm Support-Seiten:
https://de-de.facebook.com/about/privacy#
https://help.instagram.com/196883487377501
Wir als Anbieter des Informationsdienstes erheben und verarbeiten darüber hinaus keine Daten aus Ihrer Nutzung unseres Dienstes.
</p>
<p>Quelle: <a href="https://www.datenschutz.rlp.de/fileadmin/lfdi/Dokumente/Muster_Datenschutzerklaerung_Facebook.pdf">datenschutz rlp</a></p>
    <Link to="/">Go back to the homepage</Link>
  </Layout>
)


export default SecondPage
